import { Box, useTheme } from "@mui/material";
import { useState } from "react";
import SegmentedTabs from "../../../components/tabs/SegmentedTabs";
import PrebuiltTemplateGrid from "./PrebuiltTemplateGrid";
import { getOrgTokens } from "../../../theme/style/organizationPalette";

const PrebuiltTemplate = () => {
    const theme = useTheme();
    const isDark = theme.palette.mode === "dark";
    const tok = getOrgTokens(isDark);

  const all = { label: "All", value: null };
  const product = { label: "Product", value: "product" };
  const project = { label: "Project", value: "project" };
  const building = { label: "Building", value: "building" };
  const structure = { label: "Organization", value: "structure" };
  const tabs = [all, product, project, building, structure];
  const [selectedTab, setSelectedTab] = useState(all.value);
  return (
    <Box sx={{ animation: 'fadeIn 0.5s ease-out' }}>
      <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-start', maxWidth: 650 }}>
        <SegmentedTabs 
            options={tabs} 
            selected={selectedTab} 
            setSelected={setSelectedTab} 
            activeColor={tok.bg.tabActive}
        />
      </Box>
      <Box>
        <PrebuiltTemplateGrid type={selectedTab} />
      </Box>
    </Box>
  );
};
export default PrebuiltTemplate;
